module.exports = "/_next/static/images/GainCompleteViewOfYourCustomers@2x-82e738fa4970de1446dceafc160b3104.png";